import { getStorageJsonValue, SUPERSTORE_NAMESPACES, SUPERSTORE_STORAGE_ITEMS, SUPERSTORE_STORAGE_KEYS } from '../../../utils/superStoreUtils';
import { hasPushSubscriptionChangedEvent } from './serviceWorkerMessages';
export const getIsSubscriptionStale = async () => {
  try {
    const serviceWorkerExpiredTheSubscription = await hasPushSubscriptionChangedEvent();
    if (serviceWorkerExpiredTheSubscription) {
      return true;
    }
    const lastSubscribeTime = await getStorageJsonValue({
      namespace: SUPERSTORE_NAMESPACES.NOTIFICATION,
      storageKey: SUPERSTORE_STORAGE_KEYS.BROWSER,
      storageItem: SUPERSTORE_STORAGE_ITEMS.LAST_PUSH_SUBSCRIBE_TIME
    });
    if (lastSubscribeTime) {
      const timeSinceLastSubscribed = Date.now() - lastSubscribeTime;
      return timeSinceLastSubscribed >= 86400000;
    }
    return true;
  } catch (error) {
    return true;
  }
};